import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
const provincia = new datos("provincia");

export const getProvincia = async (id_pais) => {
    const provincias = new datos('provincia')
    provincias.addCondition('provincia', 'id', 0, '>')
    provincias.addCondition('provincia', 'id_pais', id_pais, '=')
    const response = await provincias.get()
    return esArray(response.wsResponse.provincia)
};

export const getProvinciaTodos = async (id_pais) => {
    const provincias = new datos('provincia')
    provincias.addCondition('provincia', 'id', 0, '>')
    const response = await provincias.get()
    return esArray(response.wsResponse.provincia)
};

export const getProvinciaPaginated = async (limit, offset) => {
    provincia.addCondition("provincia", "id", 0, ">");
    provincia.addLimitCondition(limit, offset);
    const response = await provincia.get();
    /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

    let result = {};
    if (!response.wsResponse.empty) {
        result = {
            data: esArray(response.wsResponse.provincia),
            total_records: response.wsResponse.total_records,
        };
        return result;
    }
};

export const deleteProvincia = async (id) => {
    let status = false;
    await Swal.fire({
        title: "Esta seguro de que desea eliminar esta provincia?",
        text: "Si sigue adelante, no se podran revertir los cambios!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, quiero eliminarlo!",
        cancelButtonText: "No, no estoy seguro!",
    }).then(async (result) => {
        if (result.isConfirmed) {
            const provincia = new datos("provincia");
            let data = {
                id: id,
            };
            const response = await provincia.delete(data);

            if (response.status === "true") {
                status = true;
                await Swal.fire(
                    "Eliminado!",
                    "La provincia ha sido eliminado exitosamente",
                    "success"
                );
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response.message,
                });
            }
        }
    });
    return status;
};
